import { useQuery } from "@tanstack/react-query"

import { getOrder, listOrders } from "@/features/orders/api/orders.api"

export const ordersKeys = {
  all: ["orders"] as const,
  list: (limit?: number) =>
    limit ? (["orders", "list", limit] as const) : (["orders", "list"] as const),
  detail: (id: string) => ["orders", "detail", id] as const,
}

export function useOrders(limit?: number) {
  return useQuery({
    queryKey: ordersKeys.list(limit),
    queryFn: () => listOrders(limit),
  })
}

export function useOrder(orderId: string | undefined) {
  return useQuery({
    queryKey: ordersKeys.detail(orderId ?? ""),
    queryFn: () => getOrder(orderId as string),
    enabled: !!orderId,
  })
}
